var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProviderEarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2133 24C28.6316 19.5817 28.6316 12.4183 24.2133 8C19.7951 3.58172 12.6316 3.58172 8.21335 8C3.79507 12.4183 3.79507 19.5817 8.21335 24C12.6316 28.4183 19.7951 28.4183 24.2133 24Z",
    fill: "#141416",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5156 27.0036C23.5926 25.5502 27.3408 19.4457 25.8875 13.3686C24.4341 7.29163 18.3295 3.54341 12.2525 4.99676C6.17551 6.45012 2.42729 12.5547 3.88065 18.6317C5.334 24.7087 11.4386 28.4569 17.5156 27.0036Z",
    fill: "#141416",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 24.8474C21.8868 23.6798 24.9012 18.7723 23.7336 13.8862C22.5659 9.00011 17.6584 5.98571 12.7723 7.15335C7.88627 8.32098 4.87188 13.2285 6.03951 18.1146C7.20714 23.0006 12.1146 26.015 17.0007 24.8474Z",
    fill: "#141416",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57168 16.0007C6.57234 13.6561 7.47834 11.4022 9.10064 9.70947C10.7229 8.0167 12.9362 7.01575 15.2787 6.91545C15.1481 6.91545 15.0066 6.91545 14.8869 6.91545C12.4745 6.91545 10.1608 7.87379 8.45497 9.57965C6.74911 11.2855 5.79077 13.5991 5.79077 16.0116C5.79077 18.424 6.74911 20.7377 8.45497 22.4435C10.1608 24.1494 12.4745 25.1077 14.8869 25.1077C15.0175 25.1077 15.159 25.1077 15.2787 25.1077C12.9322 25.0079 10.7154 24.0041 9.09234 22.3066C7.46932 20.609 6.56605 18.3493 6.57168 16.0007Z",
    fill: "#141416",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3165 7.27466H22.4513",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4158 8.29774H23.7873",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8308 9.86771H25.1233",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6143 11.8323H25.6728",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3219 13.9545H26.4594",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3216 18.4306H26.3802",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6295 23.7745H24.4158",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2934 24.7948H23.1586",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8814 25.8941H21.7439",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8225 6.17535H20.4865",
    stroke: "white",
    strokeWidth: 0.754583,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4758 10.4967V12.5917C17.4758 12.7062 17.4149 12.8063 17.3239 12.8618L17.3108 12.8695L16.8223 13.1516L13.9824 14.7913L13.6377 14.9903C13.6377 14.9903 13.6369 14.9907 13.6367 14.9911C13.6309 14.9936 13.6253 14.9969 13.6203 15.0006C13.5784 15.029 13.5507 15.0771 13.5507 15.1318C13.5507 15.1866 13.5784 15.2346 13.6203 15.263C13.6247 15.2659 13.6286 15.2684 13.6334 15.2707L14.0239 15.4962L15.353 16.2636C15.353 16.2636 15.3534 16.2636 15.3538 16.264L15.3775 16.2779L15.3779 16.2783C15.4187 16.3063 15.4453 16.3538 15.4453 16.4073C15.4453 16.4607 15.4187 16.5082 15.3775 16.5366L15.3545 16.5497L12.9249 17.9524L12.9114 17.96C12.867 17.9845 12.8156 17.9984 12.7613 17.9984C12.7124 17.9984 12.6658 17.987 12.6247 17.9675L12.6112 17.9602L12.5905 17.9482L11.1841 17.1361L10.7181 16.8668C10.7137 16.8645 10.7094 16.862 10.705 16.8591C10.6599 16.8318 10.6219 16.7932 10.5958 16.7472C10.5684 16.701 10.5531 16.6471 10.5531 16.5895V14.4032C10.5531 14.2902 10.6124 14.1912 10.7013 14.1358C10.7023 14.1348 10.7038 14.134 10.705 14.1333C10.7102 14.13 10.7152 14.1271 10.7208 14.1246C10.7216 14.1242 10.7222 14.1238 10.7231 14.1232L11.1843 13.8568L12.7393 12.9591L14.6136 11.8768L17.2302 10.3665C17.2345 10.3636 17.2385 10.3611 17.2433 10.3589C17.2654 10.3464 17.2913 10.3396 17.3183 10.3396C17.4053 10.3396 17.476 10.4103 17.476 10.4973L17.4758 10.4967Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6617 14.9733V17.1596C19.6617 17.274 19.6007 17.3741 19.5097 17.4293C19.5054 17.4322 19.501 17.4346 19.4967 17.4369L19.0307 17.7062L18.4412 18.0466L17.4756 18.6039L15.6013 19.6862L12.9852 21.1965C12.9808 21.1994 12.9769 21.2019 12.9721 21.2041C12.9499 21.2166 12.924 21.2234 12.8967 21.2234C12.8096 21.2234 12.7389 21.1527 12.7389 21.0657V18.9702C12.7389 18.8558 12.7999 18.7557 12.8909 18.7005C12.8971 18.6966 12.9037 18.6929 12.9101 18.6896L13.3925 18.4108L16.2323 16.7711L16.5727 16.5748C16.5727 16.5748 16.5731 16.5748 16.5735 16.5744L16.5953 16.562C16.5953 16.562 16.5967 16.5609 16.5976 16.5605C16.6384 16.5317 16.6649 16.4847 16.6649 16.4312C16.6649 16.3777 16.6371 16.3284 16.5953 16.3C16.5901 16.2966 16.5851 16.2933 16.5795 16.2908L16.1906 16.0664L14.8615 15.299C14.8615 15.299 14.8611 15.299 14.8607 15.2986L14.8352 15.2836L14.8348 15.2832C14.7948 15.2552 14.7689 15.2082 14.7689 15.1553C14.7689 15.1025 14.7944 15.0562 14.8342 15.0278C14.8342 15.0274 14.8346 15.0274 14.835 15.0274L14.8615 15.0121C14.8626 15.0111 14.864 15.0106 14.8655 15.0098L17.287 13.6115L17.3058 13.6005C17.3496 13.5773 17.4 13.564 17.4526 13.564C17.5053 13.564 17.555 13.5768 17.5983 13.5996L17.6191 13.6117L19.0303 14.4263L19.4962 14.6956C19.5006 14.6978 19.5049 14.7003 19.5093 14.7032C19.5545 14.7306 19.5924 14.7692 19.6185 14.8152C19.6459 14.8614 19.6612 14.9153 19.6612 14.9729L19.6617 14.9733Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderEarning);
export default __webpack_public_path__ + "static/media/provider-earning.8b67ef9c.svg";
export { ForwardRef as ReactComponent };